import React, { useState, useContext } from "react";
import { Grid, Typography, Input } from "@material-ui/core";
import ModalContext from "../../../../../infrastructure/Contexts/components/ModalWrapper/context";
import RecurrentPaymentAction from "../../../../../infrastructure/Contexts/components/actions/RecurrentPaymentActionsWrapper/context";
import CobeeButton from "../../../CobeeButton";
import useStyles from "./styles";
import regexTester from "../../../../../services/regexFunctions";
import { translate as t } from "../../../../../infrastructure/translate/localization";

export default function SendReportModal({
  category,
  params = {},
}: {
  category: string;
  params?: Record<string, string>;
}): JSX.Element {
  const [email, setEmail] = useState("null");
  const { closeModal } = useContext(ModalContext);
  const { sendReportEmail } = useContext(RecurrentPaymentAction);
  const { containerButton, title, label, input } = useStyles();

  return (
    <Grid>
      <Typography className={title}>
        {t("recurrent-payments-section.enter-the-email-you-want-to-send")}
      </Typography>
      <Typography className={label}>Email</Typography>
      <Input
        type="email"
        name="email"
        placeholder="Email"
        className={input}
        error={
          email !== "null" && !regexTester({ value: email, type: "email" })
        }
        onChange={(e) => setEmail(e.target.value)}
      />
      <Grid
        container
        spacing={2}
        className={containerButton}
        justifyContent="flex-end"
      >
        <Grid item>
          <CobeeButton styleType="secondary" onClick={closeModal}>
            {t("actions.cancel")}
          </CobeeButton>
        </Grid>

        <Grid item>
          <CobeeButton
            disabled={!regexTester({ value: email, type: "email" })}
            onClick={() => sendReportEmail({ category, email, ...params })}
          >
            {t("actions.send")}
          </CobeeButton>
        </Grid>
      </Grid>
    </Grid>
  );
}
